<template>
  <div class="privacy-statement">
    <a href="#privacy-en">Scroll down for English version</a>
    <h1 class="title">Datenschutz</h1>

    <h1>Datenschutzerklärung</h1>
    <p>Stand: 20. Juni 2020</p>
    <h2 class="title">Inhaltsübersicht</h2>
    <ul class="index">
      <li>
        <a class="index-link" href="#m3">Verantwortlicher</a>
      </li>
      <li>
        <a class="index-link" href="#mOverview">Übersicht der Verarbeitungen</a>
      </li>
      <li><a class="index-link" href="#m134">Einsatz von Cookies</a></li>
      <li>
        <a class="index-link" href="#m225"
          >Bereitstellung des Onlineangebotes und Webhosting</a
        >
      </li>
      <li>
        <a class="index-link" href="#m367"
          >Registrierung, Anmeldung und Nutzerkonto</a
        >
      </li>
      <li>
        <a class="index-link" href="#m15"
          >Änderung und Aktualisierung der Datenschutzerklärung</a
        >
      </li>
    </ul>
    <h2 class="title" id="m3">Verantwortlicher</h2>
    <p>
      Siehe
      <a href="http://pixelistik.de/impressum.html">Impressum</a>
    </p>
    <h2 class="title" id="mOverview">Übersicht der Verarbeitungen</h2>
    <p>
      Die nachfolgende Übersicht fasst die Arten der verarbeiteten Daten und die
      Zwecke ihrer Verarbeitung zusammen und verweist auf die betroffenen
      Personen.
    </p>
    <h3 class="title">Arten der verarbeiteten Daten</h3>
    <ul>
      <li>Bestandsdaten (z.B. Namen, Adressen).</li>
      <li>Inhaltsdaten (z.B. Texteingaben, Fotografien, Videos).</li>
      <li>Kontaktdaten (z.B. E-Mail, Telefonnummern).</li>
      <li>
        Meta-/Kommunikationsdaten (z.B. Geräte-Informationen, IP-Adressen).
      </li>
      <li>
        Nutzungsdaten (z.B. besuchte Webseiten, Interesse an Inhalten,
        Zugriffszeiten).
      </li>
    </ul>
    <h3 class="title">Kategorien betroffener Personen</h3>
    <ul>
      <li>Nutzer (z.B. Webseitenbesucher, Nutzer von Onlinediensten).</li>
    </ul>
    <h3 class="title">Zwecke der Verarbeitung</h3>
    <ul>
      <li>Sicherheitsmaßnahmen.</li>
      <li>Vertragliche Leistungen und Service.</li>
      <li>Verwaltung und Beantwortung von Anfragen.</li>
    </ul>
    <h2 class="title" id="m134">Einsatz von Cookies</h2>
    <p>
      Cookies sind Textdateien, die Daten von besuchten Websites oder Domains
      enthalten und von einem Browser auf dem Computer des Benutzers gespeichert
      werden. Ein Cookie dient in erster Linie dazu, die Informationen über
      einen Benutzer während oder nach seinem Besuch innerhalb eines
      Onlineangebotes zu speichern. Zu den gespeicherten Angaben können z.B. die
      Spracheinstellungen auf einer Webseite, der Loginstatus, ein Warenkorb
      oder die Stelle, an der ein Video geschaut wurde, gehören. Zu dem Begriff
      der Cookies zählen wir ferner andere Technologien, die die gleichen
      Funktionen wie Cookies erfüllen (z.B., wenn Angaben der Nutzer anhand
      pseudonymer Onlinekennzeichnungen gespeichert werden, auch als
      "Nutzer-IDs" bezeichnet)
    </p>
    <p>
      <strong
        >Die folgenden Cookie-Typen und Funktionen werden unterschieden:</strong
      >
    </p>
    <ul>
      <li>
        <strong
          >Temporäre Cookies (auch: Session- oder Sitzungs-Cookies):</strong
        >
        Temporäre Cookies werden spätestens gelöscht, nachdem ein Nutzer ein
        Online-Angebot verlassen und seinen Browser geschlossen hat.
      </li>
      <li>
        <strong>Permanente Cookies:</strong> Permanente Cookies bleiben auch
        nach dem Schließen des Browsers gespeichert. So kann beispielsweise der
        Login-Status gespeichert oder bevorzugte Inhalte direkt angezeigt
        werden, wenn der Nutzer eine Website erneut besucht. Ebenso können die
        Interessen von Nutzern, die zur Reichweitenmessung oder zu
        Marketingzwecken verwendet werden, in einem solchen Cookie gespeichert
        werden.
      </li>
      <li>
        <strong>First-Party-Cookies:</strong> First-Party-Cookies werden von uns
        selbst gesetzt.
      </li>
      <li>
        <strong>Third-Party-Cookies (auch: Drittanbieter-Cookies)</strong>:
        Drittanbieter-Cookies werden hauptsächlich von Werbetreibenden (sog.
        Dritten) verwendet, um Benutzerinformationen zu verarbeiten.
      </li>
      <li>
        <strong
          >Notwendige (auch: essentielle oder unbedingt erforderliche)
          Cookies:</strong
        >
        Cookies können zum einen für den Betrieb einer Webseite unbedingt
        erforderlich sein (z.B. um Logins oder andere Nutzereingaben zu
        speichern oder aus Gründen der Sicherheit).
      </li>
      <li>
        <strong>Statistik-, Marketing- und Personalisierungs-Cookies</strong>:
        Ferner werden Cookies im Regelfall auch im Rahmen der Reichweitenmessung
        eingesetzt sowie dann, wenn die Interessen eines Nutzers oder sein
        Verhalten (z.B. Betrachten bestimmter Inhalte, Nutzen von Funktionen
        etc.) auf einzelnen Webseiten in einem Nutzerprofil gespeichert werden.
        Solche Profile dienen dazu, den Nutzern z.B. Inhalte anzuzeigen, die
        ihren potentiellen Interessen entsprechen. Dieses Verfahren wird auch
        als "Tracking", d.h., Nachverfolgung der potentiellen Interessen der
        Nutzer bezeichnet. . Soweit wir Cookies oder "Tracking"-Technologien
        einsetzen, informieren wir Sie gesondert in unserer Datenschutzerklärung
        oder im Rahmen der Einholung einer Einwilligung.
      </li>
    </ul>
    <p>
      <strong>Hinweise zu Rechtsgrundlagen: </strong> Auf welcher
      Rechtsgrundlage wir Ihre personenbezogenen Daten mit Hilfe von Cookies
      verarbeiten, hängt davon ab, ob wir Sie um eine Einwilligung bitten. Falls
      dies zutrifft und Sie in die Nutzung von Cookies einwilligen, ist die
      Rechtsgrundlage der Verarbeitung Ihrer Daten die erklärte Einwilligung.
      Andernfalls werden die mithilfe von Cookies verarbeiteten Daten auf
      Grundlage unserer berechtigten Interessen (z.B. an einem
      betriebswirtschaftlichen Betrieb unseres Onlineangebotes und dessen
      Verbesserung) verarbeitet oder, wenn der Einsatz von Cookies erforderlich
      ist, um unsere vertraglichen Verpflichtungen zu erfüllen.
    </p>
    <p>
      <strong>Speicherdauer: </strong>Sofern wir Ihnen keine expliziten Angaben
      zur Speicherdauer von permanenten Cookies mitteilen (z. B. im Rahmen eines
      sog. Cookie-Opt-Ins), gehen Sie bitte davon aus, dass die Speicherdauer
      bis zu zwei Jahre betragen kann.
    </p>
    <p>
      <strong
        >Allgemeine Hinweise zum Widerruf und Widerspruch (Opt-Out):
      </strong>
      Abhängig davon, ob die Verarbeitung auf Grundlage einer Einwilligung oder
      gesetzlichen Erlaubnis erfolgt, haben Sie jederzeit die Möglichkeit, eine
      erteilte Einwilligung zu widerrufen oder der Verarbeitung Ihrer Daten
      durch Cookie-Technologien zu widersprechen (zusammenfassend als "Opt-Out"
      bezeichnet). Sie können Ihren Widerspruch zunächst mittels der
      Einstellungen Ihres Browsers erklären, z.B., indem Sie die Nutzung von
      Cookies deaktivieren (wobei hierdurch auch die Funktionsfähigkeit unseres
      Onlineangebotes eingeschränkt werden kann). Ein Widerspruch gegen den
      Einsatz von Cookies zu Zwecken des Onlinemarketings kann auch mittels
      einer Vielzahl von Diensten, vor allem im Fall des Trackings, über die
      Webseiten
      <a href="https://optout.aboutads.info" target="_blank"
        >https://optout.aboutads.info</a
      >
      und
      <a href="https://www.youronlinechoices.com/" target="_blank"
        >https://www.youronlinechoices.com/</a
      >
      erklärt werden. Daneben können Sie weitere Widerspruchshinweise im Rahmen
      der Angaben zu den eingesetzten Dienstleistern und Cookies erhalten.
    </p>
    <ul class="m-elements">
      <li>
        <strong>Verarbeitete Datenarten:</strong> Nutzungsdaten (z.B. besuchte
        Webseiten, Interesse an Inhalten, Zugriffszeiten),
        Meta-/Kommunikationsdaten (z.B. Geräte-Informationen, IP-Adressen).
      </li>
      <li>
        <strong>Betroffene Personen:</strong> Nutzer (z.B. Webseitenbesucher,
        Nutzer von Onlinediensten).
      </li>
      <li>
        <strong>Rechtsgrundlagen:</strong> Einwilligung (Art. 6 Abs. 1 S. 1 lit.
        a DSGVO), Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f. DSGVO).
      </li>
    </ul>
    <h2 class="title" id="m225">
      Bereitstellung des Onlineangebotes und Webhosting
    </h2>
    <p>
      Um unser Onlineangebot sicher und effizient bereitstellen zu können,
      nehmen wir die Leistungen von einem oder mehreren Webhosting-Anbietern in
      Anspruch, von deren Servern (bzw. von ihnen verwalteten Servern) das
      Onlineangebot abgerufen werden kann. Zu diesen Zwecken können wir
      Infrastruktur- und Plattformdienstleistungen, Rechenkapazität,
      Speicherplatz und Datenbankdienste sowie Sicherheitsleistungen und
      technische Wartungsleistungen in Anspruch nehmen.
    </p>
    <p>
      Zu den im Rahmen der Bereitstellung des Hostingangebotes verarbeiteten
      Daten können alle die Nutzer unseres Onlineangebotes betreffenden Angaben
      gehören, die im Rahmen der Nutzung und der Kommunikation anfallen. Hierzu
      gehören regelmäßig die IP-Adresse, die notwendig ist, um die Inhalte von
      Onlineangeboten an Browser ausliefern zu können, und alle innerhalb
      unseres Onlineangebotes oder von Webseiten getätigten Eingaben.
    </p>
    <p>
      <strong>E-Mail-Versand und -Hosting</strong>: Die von uns in Anspruch
      genommenen Webhosting-Leistungen umfassen ebenfalls den Versand, den
      Empfang sowie die Speicherung von E-Mails. Zu diesen Zwecken werden die
      Adressen der Empfänger sowie Absender als auch weitere Informationen
      betreffend den E-Mailversand (z.B. die beteiligten Provider) sowie die
      Inhalte der jeweiligen E-Mails verarbeitet. Die vorgenannten Daten können
      ferner zu Zwecken der Erkennung von SPAM verarbeitet werden. Wir bitten
      darum, zu beachten, dass E-Mails im Internet grundsätzlich nicht
      verschlüsselt versendet werden. Im Regelfall werden E-Mails zwar auf dem
      Transportweg verschlüsselt, aber (sofern kein sogenanntes
      Ende-zu-Ende-Verschlüsselungsverfahren eingesetzt wird) nicht auf den
      Servern, von denen sie abgesendet und empfangen werden. Wir können daher
      für den Übertragungsweg der E-Mails zwischen dem Absender und dem Empfang
      auf unserem Server keine Verantwortung übernehmen.
    </p>
    <p>
      <strong>Erhebung von Zugriffsdaten und Logfiles</strong>: Wir selbst (bzw.
      unser Webhostinganbieter) erheben Daten zu jedem Zugriff auf den Server
      (sogenannte Serverlogfiles). Zu den Serverlogfiles können die Adresse und
      Name der abgerufenen Webseiten und Dateien, Datum und Uhrzeit des Abrufs,
      übertragene Datenmengen, Meldung über erfolgreichen Abruf, Browsertyp
      nebst Version, das Betriebssystem des Nutzers, Referrer URL (die zuvor
      besuchte Seite) und im Regelfall IP-Adressen und der anfragende Provider
      gehören.
    </p>
    <p>
      Die Serverlogfiles können zum einen zu Zwecken der Sicherheit eingesetzt
      werden, z.B., um eine Überlastung der Server zu vermeiden (insbesondere im
      Fall von missbräuchlichen Angriffen, sogenannten DDoS-Attacken) und zum
      anderen, um die Auslastung der Server und ihre Stabilität sicherzustellen.
    </p>
    <ul class="m-elements">
      <li>
        <strong>Verarbeitete Datenarten:</strong> Inhaltsdaten (z.B.
        Texteingaben, Fotografien, Videos), Nutzungsdaten (z.B. besuchte
        Webseiten, Interesse an Inhalten, Zugriffszeiten),
        Meta-/Kommunikationsdaten (z.B. Geräte-Informationen, IP-Adressen).
      </li>
      <li>
        <strong>Betroffene Personen:</strong> Nutzer (z.B. Webseitenbesucher,
        Nutzer von Onlinediensten).
      </li>
      <li>
        <strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6 Abs. 1
        S. 1 lit. f. DSGVO).
      </li>
    </ul>
    <h2 class="title" id="m367">Registrierung, Anmeldung und Nutzerkonto</h2>
    <p>
      Nutzer können ein Nutzerkonto anlegen. Im Rahmen der Registrierung werden
      den Nutzern die erforderlichen Pflichtangaben mitgeteilt und zu Zwecken
      der Bereitstellung des Nutzerkontos auf Grundlage vertraglicher
      Pflichterfüllung verarbeitet. Zu den verarbeiteten Daten gehören
      insbesondere die Login-Informationen (Name, Passwort sowie eine
      E-Mail-Adresse). Die im Rahmen der Registrierung eingegebenen Daten werden
      für die Zwecke der Nutzung des Nutzerkontos und dessen Zwecks verwendet.
    </p>
    <p>
      Die Nutzer können über Vorgänge, die für deren Nutzerkonto relevant sind,
      wie z.B. technische Änderungen, per E-Mail informiert werden. Wenn Nutzer
      ihr Nutzerkonto gekündigt haben, werden deren Daten im Hinblick auf das
      Nutzerkonto, vorbehaltlich einer gesetzlichen Aufbewahrungspflicht,
      gelöscht. Es obliegt den Nutzern, ihre Daten bei erfolgter Kündigung vor
      dem Vertragsende zu sichern. Wir sind berechtigt, sämtliche während der
      Vertragsdauer gespeicherte Daten des Nutzers unwiederbringlich zu löschen.
    </p>
    <p>
      Im Rahmen der Inanspruchnahme unserer Registrierungs- und
      Anmeldefunktionen sowie der Nutzung des Nutzerkontos speichern wir die
      IP-Adresse und den Zeitpunkt der jeweiligen Nutzerhandlung. Die
      Speicherung erfolgt auf Grundlage unserer berechtigten Interessen als auch
      jener der Nutzer an einem Schutz vor Missbrauch und sonstiger unbefugter
      Nutzung. Eine Weitergabe dieser Daten an Dritte erfolgt grundsätzlich
      nicht, es sei denn, sie ist zur Verfolgung unserer Ansprüche erforderlich
      oder es besteht hierzu besteht eine gesetzliche Verpflichtung.
    </p>
    <ul class="m-elements">
      <li>
        <strong>Verarbeitete Datenarten:</strong> Bestandsdaten (z.B. Namen,
        Adressen), Kontaktdaten (z.B. E-Mail, Telefonnummern), Inhaltsdaten
        (z.B. Texteingaben, Fotografien, Videos), Meta-/Kommunikationsdaten
        (z.B. Geräte-Informationen, IP-Adressen).
      </li>
      <li>
        <strong>Betroffene Personen:</strong> Nutzer (z.B. Webseitenbesucher,
        Nutzer von Onlinediensten).
      </li>
      <li>
        <strong>Zwecke der Verarbeitung:</strong> Vertragliche Leistungen und
        Service, Sicherheitsmaßnahmen, Verwaltung und Beantwortung von Anfragen.
      </li>
      <li>
        <strong>Rechtsgrundlagen:</strong> Einwilligung (Art. 6 Abs. 1 S. 1 lit.
        a DSGVO), Vertragserfüllung und vorvertragliche Anfragen (Art. 6 Abs. 1
        S. 1 lit. b. DSGVO), Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f.
        DSGVO).
      </li>
    </ul>
    <h2 class="title" id="m15">
      Änderung und Aktualisierung der Datenschutzerklärung
    </h2>
    <p>
      Wir bitten Sie, sich regelmäßig über den Inhalt unserer
      Datenschutzerklärung zu informieren. Wir passen die Datenschutzerklärung
      an, sobald die Änderungen der von uns durchgeführten Datenverarbeitungen
      dies erforderlich machen. Wir informieren Sie, sobald durch die Änderungen
      eine Mitwirkungshandlung Ihrerseits (z.B. Einwilligung) oder eine sonstige
      individuelle Benachrichtigung erforderlich wird.
    </p>
    <p>
      Sofern wir in dieser Datenschutzerklärung Adressen und
      Kontaktinformationen von Unternehmen und Organisationen angeben, bitten
      wir zu beachten, dass die Adressen sich über die Zeit ändern können und
      bitten die Angaben vor Kontaktaufnahme zu prüfen.
    </p>
    <p class="seal">
      <a
        href="https://datenschutz-generator.de/?l=de"
        title="Rechtstext von Dr. Schwenke - für weitere Informationen bitte anklicken."
        target="_blank"
        rel="noopener noreferrer nofollow"
        >Erstellt mit kostenlosem Datenschutz-Generator.de von Dr. Thomas
        Schwenke</a
      >
    </p>

    <hr />

    <h1 class="title" id="privacy-en">Privacy</h1>

    <h1>Data protection declaration</h1>
    As of June 20, 2020
    <h2 class="title">Contents overview</h2>
    <ul class="index">
      <li>
        <a class="index-link" href="#m3">Responsible person</a>
      </li>
      <li>
        <a class="index-link" href="#mOverview"
          >Overview of the processing operations</a
        >
      </li>
      <li><a class="index-link" href="#m134">Use of cookies</a></li>
      <li>
        <a class="index-link" href="#m225"
          >Provision of the online offer and web hosting</a
        >
      </li>
      <li>
        <a class="index-link" href="#m367"
          >Registration, login and user account</a
        >
      </li>
      <li>
        <a class="index-link" href="#m15"
          >Change and update of the data protection declaration</a
        >
      </li>
    </ul>
    <h2 class="title" id="m3">Responsible person</h2>
    <p>
      See
      <a href="http://pixelistik.de/impressum.html">Imprint</a>
    </p>
    <h2 class="title" id="mOverview">Overview of processing</h2>
    <p>
      The following table summarises the types of data processed and the
      purposes of their processing and refers to the data subjects concerned.
      People.
    </p>
    <h3 class="title">Types of data processed</h3>
    <ul>
      <li>stock data (e.g. names, addresses).</li>
      <li>content data (e.g. text entries, photographs, videos).</li>
      <li>Contact details (e.g. e-mail, telephone numbers).</li>
      <li>Meta/communication data (e.g. device information, IP addresses).</li>
      <li>
        Usage data (e.g. websites visited, interest in content, access times).
      </li>
    </ul>
    <h3 class="title">Categories of persons concerned</h3>
    <ul>
      <li>user (e.g. website visitors, users of online services).</li>
    </ul>
    <h3 class="title">Purposes of processing</h3>
    <ul>
      <li>Security measures.</li>
      <li>Contractual performances and services.</li>
      <li>Manage and respond to requests.</li>
    </ul>
    <h2 class="title" id="m134">Use of cookies</h2>
    <p>
      Cookies are text files that collect data from visited websites or domains,
      which and stored by a browser on the user's computer will be. The primary
      purpose of a cookie is to store information about a user during or after
      his visit within a online offer to store. To the stored data can be added
      e.g. the language settings on a website, the login status, a shopping cart
      or the location where a video was watched. The term of the cookies, we
      also count other technologies that use the same perform functions such as
      cookies (e.g., when information from users is stored on pseudonymous
      online identifications are stored, also as "user IDs")
    </p>

    <p>
      <strong
        >The following cookie types and functions are distinguished:</strong
      >
    </p>
    <ul>
      <li>
        <strong>Temporary Cookies (also: session or session cookies):</strong>
        Temporary cookies are deleted at the latest after a user has entered a
        has left the online offer and closed his browser.
      </li>
      <li>
        <Strong>Permanent Cookies:</Strong> Permanent Cookies also remain after
        closing the browser. For example, the Login status saved or preferred
        content displayed directly when the user visits a website again.
        Likewise, the Interests of users who are interested in measuring reach
        or in used for marketing purposes are stored in such a cookie will be.
      </li>
      <li>
        <Strong>First-Party-Cookies:</Strong> First-Party-Cookies will be
        self-set.
      </li>
      <li>
        <Strong>Third Party Cookies (also: third-party cookies)</Strong>:
        Third-party cookies are mainly used by advertisers (so-called third
        parties) to process user information.
      </li>
      <li>
        <strong
          >Necessary (also: essential or absolutely necessary) Cookies:</strong
        >
        On the one hand, cookies can be essential for the operation of a website
        be necessary (e.g. to logins or other user inputs to the system) or for
        security reasons).
      </li>
      <li>
        statistics, marketing and personalization cookies: Furthermore, cookies
        are usually also used within the scope of the range measurement as well
        as when the interests of a user or his or her family are Behaviour (e.g.
        viewing certain content, using functions etc.) on individual websites
        can be stored in a user profile. Such profiles serve to display content
        to the users, for example, that correspond to their potential interests.
        This procedure will also as "tracking", i.e., following up the potential
        interests of user. . As far as we use cookies or tracking technologies
        we will inform you separately in our data protection declaration or in
        the course of obtaining consent.
      </li>
    </ul>
    <p>
      <strong>Notes on legal bases: </strong> On which Legal basis, we use your
      personal data with the help of cookies depends on whether we ask you for
      your consent. If this applies and you agree to the use of cookies, the
      Legal basis of the processing of your data the declared consent.
      Otherwise, the data processed by means of cookies will be stored on basis
      of our legitimate interests (e.g. in a business operation of our online
      offer and its commercial operation improvement) processed or, if the use
      of cookies is necessary is to fulfill our contractual obligations.
    </p>
    <p>
      <strong>Storage period: </strong>If we do not provide you with any
      explicit the storage duration of permanent cookies (e.g. in the context of
      a so called Cookie-Opt-Ins), please assume that the storage period can
      last up to two years.
    </p>

    <p>
      <strong
        >General information on withdrawal and opposition (opt-out):
      </strong>
      Depending on whether the processing is based on consent or on legal
      permission is given, you have the possibility at any time to to revoke
      your consent or to withdraw your consent to the processing of your data by
      cookie technologies (collectively referred to as "opt-out") designated).
      You can first submit your opposition using the settings of your browser,
      e.g. by explaining the use of deactivate cookies (whereby this will also
      affect the functionality of our online offer can be restricted). An
      objection against the The use of cookies for online marketing purposes can
      also be prevented by means of a variety of services, especially in the
      case of tracking, via the Websites
      <a href="https://optout.aboutads.info" target="_blank"
        >https://optout.aboutads.info
      </a>
      and
      <a href="https://www.youronlinechoices.com/" target="_blank"
        >https://www.youronlinechoices.com/</a
      >
      be explained. In addition, you can enter further notices of opposition in
      of the information on the service providers used and cookies.
    </p>
    <ul class="m-elements">
      <li>
        <strong>Processed data types:</strong> Usage data (e.g. visited
        websites, interest in content, access times), Meta/communication data
        (e.g. device information, IP addresses).
      </li>
      <li>
        <Strong> Affected persons:</Strong> Users (e.g. website visitors, users
        of online services).
      </li>
      <li>
        Legal basis: Consent (Art. 6 para. 1 p. 1 lit. a DSGVO), legitimate
        interests (Art. 6 para. 1 sentence 1 lit. f. DSGVO).
      </li>
    </ul>
    <h2 class="title" id="m225">
      Provision of the online offer and web hosting
    </h2>
    <p>
      To be able to provide our online services securely and efficiently, we
      take the services of one or more web hosting providers in claim, from
      whose servers (or servers managed by them) the online offer can be called
      up. For these purposes we can Infrastructure and platform services,
      computing capacity, storage space and database services and security
      services, and make use of technical maintenance services.
    </p>
    <p>
      With regard to the data processed in the context of the provision of the
      hosting offer data can be all the information concerning the users of our
      online offer which are incurred in the course of use and communication.
      For this purpose regularly include the IP address, which is necessary to
      to be able to deliver online offers to browsers, and all within of our
      online offer or entries made from websites.
    </p>
    <p>
      <strong>E-mail dispatch and hosting</strong>: The from us in claim web
      hosting services also include the shipping, delivery and handling of the
      Reception and storage of e-mails. For these purposes the Addresses of
      recipients and senders as well as other information concerning the e-mail
      dispatch (e.g. the providers involved) as well as the contents of the
      respective e-mails are processed. The aforementioned data may also be
      processed for SPAM detection purposes. We request to note that e-mails on
      the Internet are generally not be sent in encrypted form. As a rule,
      e-mails are sent on the transport route encrypted, but (unless a so-called
      end-to-end encryption method is used) is not limited to the servers from
      which they are sent and received. We can therefore for the transmission
      path of e-mails between the sender and the recipient on our server do not
      take any responsibility.
    </p>

    <p>
      <strong>Collection of access data and log files</strong>: We ourselves (or
      our webhosting provider) collect data about every access to the server
      (so-called server log files). The server log files can contain the address
      and Name of the websites and files called up, date and time of the call,
      transferred data volumes, message about successful retrieval, browser type
      version, the operating system of the user, referrer URL (the previously
      visited page) and usually IP addresses and the requesting provider
      ...belong.
    </p>
    <p>
      The server log files can be used for security purposes on the one hand for
      example, to avoid overloading the servers (especially in the case of
      abusive attacks, so-called DDoS attacks) and to others to ensure the
      utilization of the servers and their stability.
    </p>
    <ul class="m-elements">
      <li>
        <strong>Processed data types:</strong> Content data (e.g. text entries,
        photographs, videos), usage data (e.g. visited websites, interest in
        content, access times), Meta/communication data (e.g. device
        information, IP addresses).
      </li>
      <li>
        <Strong> Affected persons:</Strong> Users (e.g. website visitors, users
        of online services).
      </li>
      <li>
        Legal bases: (Article 6(1)) Legitimate interests p. 1 lit. f. DSGVO).
      </li>
    </ul>
    <h2 class="title" id="m367">Registration, login and user account</h2>
    <p>
      Users can create a user account. During the registration process the users
      with the required mandatory data and for purposes of the provision of the
      user account on the basis of contractual in the performance of their
      duties. The data processed include especially the login information (name,
      password and a e-mail address). The data entered during registration will
      be for the purpose of using the user account and its purpose.
    </p>
    <p>
      The users can be informed about processes that are relevant for their user
      account, such as technical changes, will be informed by e-mail. When users
      have cancelled their user account, their data will be deleted with regard
      to the user account, subject to a legal obligation to keep records,
      deleted. It is the responsibility of the users to protect their data in
      the event of termination the end of the contract. We shall be entitled to
      take back all goods delivered during the to irretrievably delete the
      user's data stored during the term of the contract.
    </p>
    <p>
      Within the scope of the use of our registration and registration functions
      as well as the use of the user account, we store the IP address and the
      time of the respective user action. The Storage takes place on the basis
      of our legitimate interests as well as of the users to protect them from
      misuse and other unauthorized access Use. A passing on of these data to
      third parties is always carried out not, unless it is necessary to pursue
      our claims or there is a legal obligation to do so.
    </p>
    <ul class="m-elements">
      <li>
        <strong>Processed data types:</strong> Stock data (e.g. names,
        addresses), contact data (e.g. e-mail, telephone numbers), content data
        (e.g. text entries, photographs, videos), meta/communication data (e.g.
        device information, IP addresses).
      </li>
      <li>
        <Strong> Affected persons:</Strong> Users (e.g. website visitors, users
        of online services).
      </li>
      <li>
        <strong>Purposes of processing:</strong> Contractual services and
        Service, security measures, management and response to requests.
      </li>
      <li>
        Legal basis: Consent (Art. 6 para. 1 p. 1 lit. a DSGVO), contract
        performance and pre-contractual enquiries (Art. 6 para. 1 p. 1 lit. b.
        DSGVO), legitimate interests (Art. 6 para. 1 sentence 1 lit. f. DSGVO).
      </li>
    </ul>
    <h2 class="title" id="m15">Amendment and update of the privacy policy</h2>
    <p>
      We kindly ask you to inform yourself regularly about the content of our
      privacy policy. We adapt the privacy policy as soon as the changes in the
      data processing carried out by us are make this necessary. We will inform
      you as soon as the changes an act of cooperation on your part (e.g.
      consent) or any other individual notification becomes necessary.
    </p>
    <p>
      Insofar as we provide addresses and other information in this privacy
      policy contact information of companies and organisations, please ask to
      note that addresses may change over time and please check the information
      before contacting us.
    </p>
  </div>
</template>
<script>
/* eslint max-lines: "off" */
export default {};
</script>
<style scoped>
.privacy-statement {
  margin-bottom: 1.5rem;
}
h2,
h3 {
  margin-top: 1.5rem;
}
</style>
